// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    DMECertificationTypeCode,
    DMECertificationTypeCodeFromJSON,
    DMECertificationTypeCodeToJSON,
    DMEConditionIndicatorCodeType,
    DMEConditionIndicatorCodeTypeFromJSON,
    DMEConditionIndicatorCodeTypeToJSON,
    DMERentalUnitPriceIndicatorCodeType,
    DMERentalUnitPriceIndicatorCodeTypeFromJSON,
    DMERentalUnitPriceIndicatorCodeTypeToJSON,
    DMEReportTransmissionCodeType,
    DMEReportTransmissionCodeTypeFromJSON,
    DMEReportTransmissionCodeTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProfessionalTemplateDurableMedicalEquipmentInformation
 */
export interface ProfessionalTemplateDurableMedicalEquipmentInformation {
    /**
     * Length of medical treatment required
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof ProfessionalTemplateDurableMedicalEquipmentInformation
     */
    x12LengthOfMedicalNecessity?: number;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProfessionalTemplateDurableMedicalEquipmentInformation
     */
    x12RentalPrice?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProfessionalTemplateDurableMedicalEquipmentInformation
     */
    x12PurchasePrice?: Amount;
    /**
     * 
     * OpenAPI data type: {DMERentalUnitPriceIndicatorCodeType}
     * @type {DMERentalUnitPriceIndicatorCodeType}
     * @memberof ProfessionalTemplateDurableMedicalEquipmentInformation
     */
    x12RentalUnitPriceIndicatorCode?: DMERentalUnitPriceIndicatorCodeType;
    /**
     * 
     * OpenAPI data type: {DMEReportTransmissionCodeType}
     * @type {DMEReportTransmissionCodeType}
     * @memberof ProfessionalTemplateDurableMedicalEquipmentInformation
     */
    x12ReportTransmissionCode?: DMEReportTransmissionCodeType;
    /**
     * 
     * OpenAPI data type: {DMECertificationTypeCode}
     * @type {DMECertificationTypeCode}
     * @memberof ProfessionalTemplateDurableMedicalEquipmentInformation
     */
    x12CertificationCode?: DMECertificationTypeCode;
    /**
     * Length of time DME equipment is needed
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof ProfessionalTemplateDurableMedicalEquipmentInformation
     */
    x12CertificationDuration?: number;
    /**
     * 
     * OpenAPI data type: {DMEConditionIndicatorCodeType}
     * @type {DMEConditionIndicatorCodeType}
     * @memberof ProfessionalTemplateDurableMedicalEquipmentInformation
     */
    x12PrimaryConditionIndicator?: DMEConditionIndicatorCodeType;
    /**
     * 
     * OpenAPI data type: {DMEConditionIndicatorCodeType}
     * @type {DMEConditionIndicatorCodeType}
     * @memberof ProfessionalTemplateDurableMedicalEquipmentInformation
     */
    x12SecondaryConditionIndicator?: DMEConditionIndicatorCodeType;
    /**
     * Certification revision or recertification date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProfessionalTemplateDurableMedicalEquipmentInformation
     */
    x12CertificationRevisionDate?: string;
    /**
     * Begin therapy date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProfessionalTemplateDurableMedicalEquipmentInformation
     */
    x12BeginTherapyDate?: string;
    /**
     * Certification revision or recertification date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProfessionalTemplateDurableMedicalEquipmentInformation
     */
    x12LastCertificationDate?: string;
}

export function ProfessionalTemplateDurableMedicalEquipmentInformationFromJSON(json: any): ProfessionalTemplateDurableMedicalEquipmentInformation {
    return {
            'x12LengthOfMedicalNecessity': !exists(json, 'x12LengthOfMedicalNecessity') ? undefined : json['x12LengthOfMedicalNecessity'],
            'x12RentalPrice': !exists(json, 'x12RentalPrice') ? undefined : AmountFromJSON(json['x12RentalPrice']),
            'x12PurchasePrice': !exists(json, 'x12PurchasePrice') ? undefined : AmountFromJSON(json['x12PurchasePrice']),
            'x12RentalUnitPriceIndicatorCode': !exists(json, 'x12RentalUnitPriceIndicatorCode') ? undefined : DMERentalUnitPriceIndicatorCodeTypeFromJSON(json['x12RentalUnitPriceIndicatorCode']),
            'x12ReportTransmissionCode': !exists(json, 'x12ReportTransmissionCode') ? undefined : DMEReportTransmissionCodeTypeFromJSON(json['x12ReportTransmissionCode']),
            'x12CertificationCode': !exists(json, 'x12CertificationCode') ? undefined : DMECertificationTypeCodeFromJSON(json['x12CertificationCode']),
            'x12CertificationDuration': !exists(json, 'x12CertificationDuration') ? undefined : json['x12CertificationDuration'],
            'x12PrimaryConditionIndicator': !exists(json, 'x12PrimaryConditionIndicator') ? undefined : DMEConditionIndicatorCodeTypeFromJSON(json['x12PrimaryConditionIndicator']),
            'x12SecondaryConditionIndicator': !exists(json, 'x12SecondaryConditionIndicator') ? undefined : DMEConditionIndicatorCodeTypeFromJSON(json['x12SecondaryConditionIndicator']),
            'x12CertificationRevisionDate': !exists(json, 'x12CertificationRevisionDate') ? undefined : json['x12CertificationRevisionDate'],
            'x12BeginTherapyDate': !exists(json, 'x12BeginTherapyDate') ? undefined : json['x12BeginTherapyDate'],
            'x12LastCertificationDate': !exists(json, 'x12LastCertificationDate') ? undefined : json['x12LastCertificationDate'],
    };

}

export function ProfessionalTemplateDurableMedicalEquipmentInformationToForm(value?: ProfessionalTemplateDurableMedicalEquipmentInformation): any {
    let jsonVal = ProfessionalTemplateDurableMedicalEquipmentInformationToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProfessionalTemplateDurableMedicalEquipmentInformationToJSON(value?: ProfessionalTemplateDurableMedicalEquipmentInformation): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'x12LengthOfMedicalNecessity': cleanupBlankValuesForBackend(value.x12LengthOfMedicalNecessity),
            'x12RentalPrice': AmountToJSON(value.x12RentalPrice),
            'x12PurchasePrice': AmountToJSON(value.x12PurchasePrice),
            'x12RentalUnitPriceIndicatorCode': DMERentalUnitPriceIndicatorCodeTypeToJSON(value.x12RentalUnitPriceIndicatorCode),
            'x12ReportTransmissionCode': DMEReportTransmissionCodeTypeToJSON(value.x12ReportTransmissionCode),
            'x12CertificationCode': DMECertificationTypeCodeToJSON(value.x12CertificationCode),
            'x12CertificationDuration': cleanupBlankValuesForBackend(value.x12CertificationDuration),
            'x12PrimaryConditionIndicator': DMEConditionIndicatorCodeTypeToJSON(value.x12PrimaryConditionIndicator),
            'x12SecondaryConditionIndicator': DMEConditionIndicatorCodeTypeToJSON(value.x12SecondaryConditionIndicator),
            'x12CertificationRevisionDate': cleanupBlankValuesForBackend(value.x12CertificationRevisionDate),
            'x12BeginTherapyDate': cleanupBlankValuesForBackend(value.x12BeginTherapyDate),
            'x12LastCertificationDate': cleanupBlankValuesForBackend(value.x12LastCertificationDate),
    };
}


